import Vue from 'vue'
import Vuex from 'vuex'
import {clientProjectSettings} from "../classes/ClientProjectSettingsClass";
import {CryptoHelper} from "../classes/CryptoHelper";
import GeoLocationHelper from "../helpers/geoLocation/GeoLocationHelper";
import VueCookies from 'vue-cookies'
import {isAuthenticatedCookie} from "@/auth/sanctum/constants";
import {pref_lang_skey} from "@/helpers/userLanguage/UserLanguageHelper";
import {workSessionStorageHelper} from "@/workSessions/helpers/workSessionStorageHelper";


Vue.use(Vuex)

export const storageKey_CPS = 'clientProjectSettings';
export const unknownLocationMsg = 'Could not get users location';
export const privateLocationMsg = 'Private location';
export const noLocationSupportMsg = 'Browser does not support geolocation';

//START STOP STUFF...
export const startedNormal = 'NORMAL';
export const startedStaticThreeState = 'STATICTHREESTATELMRA';
export const startedLoto = 'LOTO';

export const startWorkEvent = 'userIsStartingWork';
export const stopWorkEvent = 'userIsStoppingWork';
//END START STOP


export default new Vuex.Store({
    state: {
        snackbar_showing: false,
        snackbar_message: null,
        userHash: null,
        location_is_private: false,
        current_location: null,
        is_updating_location: false,
        last_successful_location_update: null,
        currentClientProjectSettings: new clientProjectSettings(null, null, '', '', ''),
        sendingLMRRAData: false,
        loadingResourceData : false,
        capsSaveValidated: false,
        userStartStopEvent: false,
        userStartEventType: false,
        auth0UnverifiedEmailError: false,
        userLanguage: (localStorage.getItem(pref_lang_skey)) ? localStorage.getItem(pref_lang_skey) : null,
        latestVersionInfo : {
            'minimum_required_version' : null,
            'latest_version' : null
        }
    },
    getters: {
        //NOT USED ANYMORE??? userdata is in session :)
        getRawUserIdForDataTransfer: (state, getters, rootState) => {
            return rootState.auth.currentUser.email;
        },
        getUserId: state => {
            return state.userHash;
        },
        getProjectDistance: state => {
            return state.currentClientProjectSettings.project_distance;
        },
        getProjectShift: state => {
            return state.currentClientProjectSettings.project_shift;
        },
        getProjectId: state => {
            return state.currentClientProjectSettings.project;
        },
        getProjectTagCode: state => {
            return state.currentClientProjectSettings.project_tag_code;
        },
        getClientName: state => {
            return state.currentClientProjectSettings.client;
        },
        getUserCurrentLocation: state => {
            if (!state.location_is_private) {
                if (state.current_location !== null) {
                    return state.current_location;
                } else {
                    return {'error': unknownLocationMsg}
                }
            } else {
                return {'error': privateLocationMsg}
            }
        },
        getHasAuth0UnverifiedEmailErrorState: state => {
            return state.auth0UnverifiedEmailError
        },
        getUserLanguage: state => state.userLanguage,
        currentClientProjectSettings: state => state.currentClientProjectSettings,
        getWebAppVersionInfo : state => state.latestVersionInfo
    },
    mutations: {
        launchSnackbarMessage(state, message) {
            state.snackbar_message = message;
            state.snackbar_showing = true
        },
        hideSnackbarMessage(state) {
            state.snackbar_message = null;
            state.snackbar_showing = false;
        },
        lockLocationUpdate(state) {
            state.is_updating_location = true;
        },
        unlockLocationUpdate(state) {
            state.is_updating_location = false;
        },
        updateUserGeoLocation(state, payload) {
            //RELEASE UPDATE LOCK
            this.commit('unlockLocationUpdate');

            //GET CURRENT LOCAL MACHINE TIME...
            /*
            IF WE RECEIVE AN ERROR WE CHECK IF THE PREVIOUS LOCATION / MESSAGE
            IS OLDER THAN 15 MINS, IF IT ISN'T WE DON'T UPDATE THE ERROR
            AND TRY TO USE THE LAST GATHER LOCATION DATA
            IF A NON ERROR LOCATION UPDATE IS FOUND WE UPDATE IT
            */
            let curr_time = Math.floor(Date.now() / 1000);
            if (payload.error !== undefined) {
                //console.log('ERROR RECEIVED');
                //check if has been collected within 15mins
                if ((curr_time - state.last_successful_location_update) < 900) {
                    //15Min haven't passed yet so keep previous location.
                    //console.log('LESS 15 min -- NO ACTION !!')
                    return false;
                }
            }

            state.current_location = payload;
            this.commit('setLocationUpdateTimeStamp', curr_time);
        },
        setLocationUpdateTimeStamp(state, payload) {
            //console.log('TIMESTAMP !!! UPD');
            //console.log(payload);
            state.last_successful_location_update = payload;
        },
        setPrivateLocationState(state, privateState) {
            state.location_is_private = privateState;
        },
        setUserId(state, payload) {
            let crypto = new CryptoHelper();
            state.userHash = crypto.createMD5FromString(payload);
        },
        loadStoredClientProjectSettings(state) {
            let storedClientProjectSettings = {}

            if (localStorage.getItem(storageKey_CPS)) {
                try {
                    storedClientProjectSettings = JSON.parse(localStorage.getItem(storageKey_CPS));
                    if (storedClientProjectSettings[state.userHash] !== undefined) {
                        Object.assign(state.currentClientProjectSettings, storedClientProjectSettings[state.userHash]);
                    } else {
                        state.currentClientProjectSettings = new clientProjectSettings('', '', '', '');
                    }
                } catch (e) {
                    localStorage.removeItem(storageKey_CPS);
                }
            }
        },
        setClientProjectSettings(state, payload) {
            if (payload instanceof clientProjectSettings) {
                //console.log('all good...')

                //console.log('mutating');
                //console.log(payload);
                Object.assign(state.currentClientProjectSettings, payload);

                let storedClientProjectSettings = {}

                if (localStorage.getItem(storageKey_CPS)) {
                    try {
                        storedClientProjectSettings = JSON.parse(localStorage.getItem(storageKey_CPS))
                    } catch (e) {
                        localStorage.removeItem(storageKey_CPS);
                    }
                }
                storedClientProjectSettings[state.userHash] = payload;
                localStorage.setItem(storageKey_CPS, JSON.stringify(storedClientProjectSettings));
            }
        },
        setSendingLMRADataState(state, payload) {
            state.sendingLMRRAData = payload;
        },
        setLoadingResourceDataState(state, payload){
            state.loadingResourceData = payload;
        },
        setCAPSSaveValidatedState(state, isValidated) {
            state.capsSaveValidated = isValidated;
        },
        setUserStartEventType(state, payload) {
            //console.log('REACHED PAYLOAD DELIVERY', payload);
            state.userStartEventType = payload;
        },
        setUserStartStopEvent(state, payload) {
            //console.log('REACHED PAYLOAD DELIVERY 2', payload);
            state.userStartStopEvent = payload;
        },
        setAuth0UnverifiedEmailErrorState(state, payload) {
            state.auth0UnverifiedEmailError = payload;
        },
        setUserLanguage(state, $lang) {
            state.userLanguage = $lang
        },
        setLatestVersionInfo(state, $vInfo){
            state.latestVersionInfo = $vInfo
        }
    },
    actions: {
        storeCAPS({commit}, payload) {
            commit('setClientProjectSettings',
                payload
            );
            //Settings commit now update the state
            commit('setCAPSSaveValidatedState', true);
        },
        async getAuth0UserEmail() {
            //console.log('STORE CALLED');
            let user_id = await this.$auth.user.email;
            window.console.log(user_id);
        },
        async getUserLocation({commit}) {
            //window.console.log('STARTED GATHERING INFO');
            if (this.state.is_updating_location) {
                //window.console.log('ALREADY UPDATING');
                return;
            }

            let locationObject = {}
            try {
                commit('lockLocationUpdate');
                let locationData = await GeoLocationHelper.getCurrentGeoLocation();

                if (locationData.coords.latitude === undefined || locationData.coords.longitude === undefined) {
                    throw new Error('LOCATIONDATA-INVALID');
                }

                locationObject['latitude'] = locationData.coords.latitude;
                locationObject['longitude'] = locationData.coords.longitude;

                //window.console.log('CHECKED AND FOUND');

            } catch (error) {
                //window.console.log('ERROR !!')
                switch (error.message) {
                    case 'LOCATION-NOT-AVAILABLE':
                        locationObject['error'] = noLocationSupportMsg;
                        break;
                    case 'LOCATIONDATA-INVALID':
                    default :
                        locationObject['error'] = unknownLocationMsg;
                }
            }

            //window.console.log('UPDATING LOCATION');
            commit('updateUserGeoLocation', locationObject);
        },
        async setUserLanguage({commit}, $lang) {
            commit('setUserLanguage', $lang);
        },
        async setLoadingResourceState({commit}, $state){
            await commit('setLoadingResourceDataState', $state);
        },
        async setWebAppVersionInformation({commit}, $vInfo){
            await commit('setLatestVersionInfo', $vInfo);
        }
    },
    modules: {
        auth: {
            state: () => ({
                authenticated: VueCookies.get(isAuthenticatedCookie) ? JSON.parse(VueCookies.get(isAuthenticatedCookie)) : null,
                currentUser: null,
            }),
            getters: {
                authenticated: state => state.authenticated,
                currentUser: state => state.currentUser,
            },
            mutations: {
                SET_AUTHENTICATED(state, $isAuthenticated) {
                    state.authenticated = $isAuthenticated
                },
                SET_CURRENT_USER(state, $user) {
                    state.currentUser = $user;
                }
            },
            actions: {
                async setUserAuthenticated({commit}) {
                    commit('SET_AUTHENTICATED', true)
                    VueCookies.set(isAuthenticatedCookie, true, "2y")
                },
                async setUserLoggedOut({commit, dispatch}) {
                    VueCookies.remove(isAuthenticatedCookie);
                    await commit('SET_AUTHENTICATED', null);
                    //CLEAR THE ACTIVE SESSION!
                    await dispatch('clearSavedSessionData');
                },
                async setCurrentUser({commit}, $currentUser) {
                    commit('SET_CURRENT_USER', $currentUser);
                    //comes from head module
                    commit('setUserId', $currentUser.email);
                    commit('loadStoredClientProjectSettings');

                }
            }
        },
        customLmraLists: {
            state: () => ({
                currentValidatedCustomLmraList: null,
            }),
            getters: {
                getCurrentValidatedCustomLmraList: state => state.currentValidatedCustomLmraList,
            },
            mutations: {
                SET_CURRENT_CUSTOM_LMRA_LIST(state, $validatedCustomLmraList) {
                    state.currentValidatedCustomLmraList = $validatedCustomLmraList;
                }
            },
            actions: {
                async setCurrentCustomLmraList({commit}, $validatedCustomLmraList) {
                    commit('SET_CURRENT_CUSTOM_LMRA_LIST', $validatedCustomLmraList)
                }
            }
        },
        dynamicQuestionList: {
            state: () => ({
                currentValidatedDynamicQuestionList: null,
            }),
            getters: {
                getCurrentValidatedDynamicQuestionList : state => state.currentValidatedDynamicQuestionList
            },
            mutations: {
                SET_CURRENT_DYNAMIC_QUESTION_LIST(state, $validatedDynamicQuestionList) {
                    state.currentValidatedDynamicQuestionList = $validatedDynamicQuestionList;
                }
            },
            actions: {
                async setCurrentDynamicQuestionList({commit}, $validatedDynamicQuestionList) {
                    commit('SET_CURRENT_DYNAMIC_QUESTION_LIST', $validatedDynamicQuestionList)
                }
            }
        },
        workSessions : {
            state: () => ({
                activeWorkSession : null
            }),
            getters : {
                getActiveWorkSession : state => state.activeWorkSession,
            },
            mutations: {
                SET_ACTIVE_WORK_SESSION(state, $verifiedWorkSession){
                    state.activeWorkSession = $verifiedWorkSession
                }
            },
            actions: {
                async saveValidatedAndVerifiedWorkSession({dispatch}, $validatedAndVerifiedWorkSession){
                    let result = await workSessionStorageHelper.encodeAndStoreWorkSessionData($validatedAndVerifiedWorkSession);
                    if(result){
                        await dispatch('storeValidatedAndVerifiedWorkSessionInMemory', $validatedAndVerifiedWorkSession);
                        return true;
                    }else{
                       return false;
                    }
                },
                async storeValidatedAndVerifiedWorkSessionInMemory({commit}, $validatedAndVerifiedWorkSession){
                    await commit('SET_ACTIVE_WORK_SESSION', $validatedAndVerifiedWorkSession)
                },
                async clearActiveSession({commit}){
                    window.console.log('CLEARING Active Session!!!!');
                    await commit('SET_ACTIVE_WORK_SESSION', null)
                },
                async clearSavedSessionData({dispatch}){
                    await workSessionStorageHelper.clearWorkSessionData()
                    await dispatch('clearActiveSession');
                }
            },
        }
    }
})